export default __webpack_public_path__ + "static/media/popAd3.de74d4e9.gif";